const ROUTES = {
    MAIN_ROUTE: '/',
    LOGIN: '/Login',
  };

  export default ROUTES;